<template>

    <v-app id="inspire">
        <v-layout row justify-center>
            <v-dialog v-model="onShow" persistent max-width="65%">
                <v-card>
                    <v-card-title>
                        <span class="subheading">MARS - Assign rights to role: {{ role.name }}</span>
                    </v-card-title>

                    <v-divider></v-divider>

                    <v-container grid-list-xs style="overflow-y: auto; margin-top: -20px">
                        <v-layout row wrap>

                            <v-flex class="modal-flex-height" xs3 sm3 md3 v-if="editMode">
                                <v-subheader>App rights:</v-subheader>
                            </v-flex>

                            <v-flex xs9 sm9 md9 v-if="editMode">
                                <v-container id="scroll-target" style="max-height: 200px" class="scroll-y">
                                    <v-list-tile v-for="roleAppRight in roleAppRightEntries"
                                                 v-bind:key="roleAppRight.right.rightId">
                                        <v-list-tile-content>
                                            <v-checkbox :key="roleAppRight.right.rightId"
                                                        :label="roleAppRight.right.name"
                                                        v-model="roleAppRight.rightSelected"
                                                        :disabled="disabled"
                                                        @click.native="onAppRightSelected(roleAppRight)"></v-checkbox>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                </v-container>
                            </v-flex>


                            <v-flex class="modal-flex-height" xs12 sm12>
                                <v-subheader>Pool group rights:</v-subheader>
                            </v-flex>

                            <v-flex v-if="editMode">
                                <v-container id="scroll-target" style="max-height: 250px; padding: unset"
                                             class="scroll-y">
                                    <v-data-table :headers="rolePoolGroupRightEntries[0]"
                                                  :items="rolePoolGroupRightEntries" hide-actions>

                                        <template slot="headers" slot-scope="props">
                                            <tr>
                                                <th></th>
                                                <th v-for="header in props.headers" v-bind:key="header.right.rightId"
                                                    class="subheading text-xs-left">{{header.right.name}}
                                                </th>
                                            </tr>
                                        </template>
                                        <template slot="items" slot-scope="props">
                                            <td class="text-xs-left">{{ props.item[0].poolGroup.name }}</td>
                                            <td v-for="it in props.item" v-bind:key="it.right.rightId"
                                                class="text-xs-center">
                                                <v-checkbox :value="it.rightSelected" :key="it.right.rightId"
                                                            v-model="it.rightSelected"
                                                            :disabled="disabled"
                                                            @click.native="onPoolGroupRightSelected(it)"></v-checkbox>
                                            </td>
                                        </template>
                                    </v-data-table>
                                </v-container>
                            </v-flex>
                        </v-layout>
                    </v-container>

                    <v-alert :value="error" type="error" transition="scale-transition">
                        {{ errorMessage }}
                    </v-alert>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn id="save_role_right_assignment_button" class="text-none" color="green" small dark @click="onSaveRoleRightAssignments"
                               :disabled="disabled">
                            Save
                        </v-btn>
                        <v-btn id="cancel_role_right_assignment_button" class="text-none" small @click="close">Cancel</v-btn>
                    </v-card-actions>

                </v-card>
            </v-dialog>
        </v-layout>
    </v-app>
</template>

<script>

    import rolerightinterface from "../../../../interfaces/rolerightinterface";
    import {EventBus} from "../../../../eventbus";
    import errormessagemanager from "../../../../managers/errormessagemanager";


    export default {
        name: 'AssignRightsToRoleModal',
        props: {
            value: Boolean,

            editMode: Boolean,
            disabled: Boolean,
            role: {
                roleId: Number,
                name: String,
                description: String,
                roleAppRights: Array,
                rolePoolGroupRights: Array
            },

            roleAppRightEntries: Array,
            rolePoolGroupRightEntries: Array
        },

        data: () => ({
            changedAppRights: [],

            changedPoolGroupRights: [],
            error: false,
            errorMessage: null
        }),


        computed: {
            getTitle: function () {
                return this.editMode ? "Edit" : "Create";
            },

            onShow: {
                get() {
                    return this.value
                },
                set(value) {
                    this.$emit('input', value)
                }
            }
        },

        methods: {

            async onSaveRoleRightAssignments() {
                this.clearAlert();

                await this.savePoolGroupRights();
                await this.saveAppRights();
                
                if (!this.error) {
                    await EventBus.$emit('refreshRoleList');
                    await this.close();
                }
            },

            async saveAppRights() {
                if (this.changedAppRights != null && this.changedAppRights.length > 0) {
                    for (const changedAppRight of this.changedAppRights) {
                        let res = null;

                        if (changedAppRight.rightSelected) {
                            await rolerightinterface.postRoleAppRight(changedAppRight, responseObj => {
                                res = responseObj;
                            });
                        } else {
                            await rolerightinterface.deleteRoleAppRight(changedAppRight, responseObj => {
                                res = responseObj;
                            });
                        }

                        if (res != null && res.error) {
                            this.error = res.error;
                            errormessagemanager.getUpdateErrorMessage(res.status, message => {
                                this.errorMessage = message;
                            });
                        }
                    }
                }
            },

            async savePoolGroupRights() {
                if (this.changedPoolGroupRights != null && this.changedPoolGroupRights.length > 0) {
                    for (const changedRoleRight of this.changedPoolGroupRights) {
                        let res = null;

                        if (changedRoleRight.rightSelected) {
                            await rolerightinterface.postRolePoolGroupRight(changedRoleRight, responseObj => {
                                res = responseObj;
                            });
                        } else {
                            await rolerightinterface.deleteRolePoolGroupRight(changedRoleRight, responseObj => {
                                res = responseObj;
                            });
                        }

                        if (res != null && res.error) {
                            this.error = res.error;
                            errormessagemanager.getUpdateErrorMessage(res.status, message => {
                                this.errorMessage = message;
                            });
                        }
                    }
                }
            },

            onPoolGroupRightSelected(it) {

                let containedIndex = -1;

                this.changedPoolGroupRights.forEach(roleRight => {
                    if (roleRight.role != null && it.role != null && roleRight.poolGroup.poolGroupId === it.poolGroup.poolGroupId
                        && roleRight.right != null && it.right != null && roleRight.right.rightId === it.right.rightId) {
                        containedIndex = this.changedPoolGroupRights.indexOf(roleRight);
                    }
                });

                if (containedIndex !== -1) {
                    this.changedPoolGroupRights.splice(containedIndex, 1);
                } else {
                    this.changedPoolGroupRights.push(it)
                }
            },

            onAppRightSelected(it) {
                let containedIndex = -1;

                this.changedAppRights.forEach(appRight => {
                    if (appRight.role != null && it.role != null && appRight.right != null && it.right != null
                        && appRight.right.rightId === it.right.rightId) {
                        containedIndex = this.changedAppRights.indexOf(appRight);
                    }
                });

                if (containedIndex !== -1) {
                    this.changedAppRights.splice(containedIndex, 1);
                } else {
                    this.changedAppRights.push(it);
                }
            },

            async close() {
                await this.$emit('roleModalClosed');
                this.onShow = false;

                this.clearData();
                this.clearAlert();
            },

            clearData() {
                this.role.roleId = null;
                this.role.name = null;
                this.role.description = null;
                this.roleAppRightEntries = null;
                this.rolePoolGroupRightEntries = null;

                this.changedAppRights = [];
                this.changedPoolGroupRights = [];

                this.$validator.errors.clear();
                this.$validator.fields.items.forEach(field => field.reset());
                this.$validator.fields.items.forEach(field => this.errors.remove(field));
                this.$validator.resume();
            },

            clearAlert() {
                this.error = false;
                this.errorMessage = null;
            }
        }
    }

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/common/roles/modals/AssignRightsToRoleModal.vue